/**
 * Authorize – L'Authorize project translations
 * Add section files (e.g. products.js) as needed
 */

export default {};
